import { IInitPaymentExtraData } from '../../../../repositories/billing-accounts/entities/CloudPayments/InitPaymentExtraData';
import { ICloudPaymentsWidgetData } from '../types';

export const mapData = (data: IInitPaymentExtraData | null | undefined): ICloudPaymentsWidgetData | null => {
  if (!data?.insertedClient) {
    return null;
  }

  return {
    insertedClient: data.insertedClient,
  };
};
